<div class="collapse" [ngbCollapse]="collapse_experience" id="dateposted-05">
  <div class="bg-light p-3 mt-4">
    <form class="form-row" [formGroup]="form">
      <div class="form-group col-md-12">
        <label>Job Title</label>
        <input type="text" class="form-control" formControlName="title">
      </div>
      <div class="form-group col-md-12">
        <label>Company name</label>
        <input type="text" class="form-control" formControlName="company">
      </div>
      <div class="form-group col-md-6 select-border">
        <label>From</label>
        <div class="input-group">
          <input class="form-control" placeholder="yyyy-mm-dd" name="dpFrom" [formControl]="form.controls.fromDate"
            ngbDatepicker #d="ngbDatepicker" [maxDate]="maxDate">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-6 select-border">
        <label>To</label>
        <div class="input-group">
          <input class="form-control" placeholder="yyyy-mm-dd" [minDate]="minfromDate" name="dpTo"
            [formControl]="form.controls.toDate" ngbDatepicker #e="ngbDatepicker" [maxDate]="maxDate">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="e.toggle()" type="button"></button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-6 select-border">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="" id="currentJobChecked" [formControl]="form.controls.currentJob">
          <label class="form-check-label" for="currentJobChecked">
            Current Job
          </label>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label>Description</label>
        <textarea class="form-control" rows="4" formControlName="description"></textarea>
      </div>
      <div class="attachments">
        <app-experience-attachment [experienceId]="experience.id"
          [resetAttachmentFormEvent]="resetAttachmentFormEvent"></app-experience-attachment>
        <app-attachments-preview [attachments]="experience.attachments"></app-attachments-preview>
      </div>
      <div class="form-group col-md-12 mb-0">
        <a class="btn btn-md btn-primary" [routerLink]="" (click)="save()">{{buttonText}}</a>
      </div>
    </form>
  </div>
</div>